import { useAppSelector } from '@/app/hooks';
import { useSmallScreen, useTablet } from '@/hooks/useWindowDimension';
import { GroupAnalysisType } from '@/generated/types/navigator/types.gen';

/**
 * Custom hook to determine if the app is in mobile inspect mode
 * Mobile inspect mode is active when:
 * - Device is small screen OR tablet dimensions
 * - AND inspect mode is enabled
 * - AND selected analysis is NOT fall-in type
 */
export const useMobileInspectMode = () => {
  const { isInspectMode, selectedAnalysis } = useAppSelector(
    (s) => s.analysisMap
  );
  const isSmallScreen = useSmallScreen();
  const tabletDimensions = useTablet();

  const isMobileInspectMode =
    (isSmallScreen || tabletDimensions) &&
    isInspectMode &&
    selectedAnalysis !== GroupAnalysisType.FALL_IN;

  return isMobileInspectMode;
};
